import { css } from '@emotion/react';

export const styles = {
  headerFlex: css({ width: '100%', justifyContent: 'space-between' }),
  noMargin: css({ margin: 0 }),
  quantityTag: css({ fontSize: 16, padding: '4px 12px' }),
  descriptionBlock: css({ width: '100%', marginBottom: 12 }),
  smallText: css({ fontSize: '0.85em' }),
  eventCard: css({ backgroundColor: '#fafafa' }),
  dateText: css({ color: '#1890ff' }),
  locationRow: css({ marginTop: 4 }),
  hintIcon: css({ color: 'rgba(0,0,0,0.45)', cursor: 'help', marginLeft: 4, fontSize: 14 }),
  historyBtn: css({ display: 'flex', alignItems: 'center', gap: 4 }),
  eventName: css({ fontWeight: 500, fontSize: 14 }),
  eventMeta: css({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap' as const,
  }),
  partialQty: css({
    fontSize: '0.85em',
    color: '#fa8c16',
  }),
  eventActions: css({
    marginLeft: 'auto',
  }),
  measurementBlock: css({ marginBottom: 16 }),
  measurementLabel: css({ display: 'block', marginBottom: 8 }),
  measurementTimeline: css({ borderLeft: '2px solid #d9d9d9', paddingLeft: 12 }),
  measurementRow: css({ marginBottom: 4, display: 'flex', gap: 12 }),
  measurementDate: css({ minWidth: 120 }),
  locationEntry: css({ marginBottom: 4 }),
  locationDate: css({ display: 'block', marginBottom: 2 }),
};
